import ProcessimLabsFaq from "./ProcessimLabsFaq";

export default ProcessimLabsFaq;
